export const INQUIRY_TYPE__CUSTOMER = "customer";
export const INQUIRY_TYPE__BANK_ADVISOR = "bankAdvisor";
export const INQUIRY_TYPE__GUARANTEE_AGENT = "guaranteeAgent";
export const INQUIRY_TYPE__LEASING_ADVISOR = "leasingAdvisor";
